// Module
var code = "<script>let $ctrl</script> <section class=\"font-link molecule-link-with-icon\" ng-click=\"$ctrl.gotoRoute()\" ng-keyup=\"$ctrl.keyUpEventCheck($event)\"> <fa-icon ng-if=\"$ctrl.iconName.length > 0\" class=\"molecule-link-with-icon__icon\" icon=\"{{ $ctrl.iconName }}\"></fa-icon> <atom-html html=\"{{ $ctrl.html }}\"></atom-html> </section> ";
// Exports
module.exports = code;